import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { withRouter } from "react-router-dom";
import uuid from 'uuid/v1';
import moment from 'moment';
import  Page  from '../../components/Page';
import {  ProductFilter } from '../../components';
import { NetworkContext } from '../../context/NetworkContext';

import { Header, Results } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    padding: theme.spacing(3)
  },
  results: {
    marginTop: theme.spacing(3)
  }
}));
export const Products = withRouter(props => {

  const classes = useStyles();
  const [orders, setOrders] = useState([]);
  const { sendNetworkRequest } = React.useContext(NetworkContext);
  const [masters, setMasters] = useState({});
  const [totalcount, setTotalcount] = useState(1);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  
  const [filterparams, setFilterparams] = useState({});
  function  applysearch(searchtext)
  {
      let searchcontent = {
        ...filterparams,
        'searchtext' : searchtext
      }
      setFilterparams({
        ...searchcontent
      })
      fetchallproducts(searchcontent)
  }
  function onPageChange(page)
  {
    setPage(page)
  }

  async function onUpdatestatus(indexval,ischecked)
  {
	let bodycontent = {
		product_id : orders[indexval].id,
		status : ischecked
	}
	let products = await sendNetworkRequest('/admin/updateproductstatus', {}, bodycontent,true)
	
	fetchallproducts(filterparams)
    
  }
  function onPageLimit(limit)
  {
    setRowsPerPage(limit)
  }
  function  applyfilter(filtercontent)
  {
    setPage(0)
    setFilterparams({
      ...filtercontent
    })
    fetchallproducts(filtercontent)
  }
  async function fetchallproducts(filtercontent)
  {
    let bodycontent = {
      ...filtercontent,
      page: page ,
      limit: rowsPerPage
  }

    let products = await sendNetworkRequest('/admin/getproducts', {}, bodycontent,true)
    setTotalcount(products.module.count)
    setOrders(products.module)
  }
  async function fetchmasters()
  {
    let commodities = await sendNetworkRequest('/admin/getparentcommodity', {}, {},false)
    
    //let versions = await sendNetworkRequest('/fetchappversions', {}, {},false)
    setMasters({
      ...masters,
      commodity : commodities.module
    })
  }
  useEffect(() => {
 //   fetchmasters()
  
  }, []);
  useEffect(() => {
    fetchallproducts(filterparams)
  }, [page,rowsPerPage]);
  return (
    <Page
      className={classes.root}
      title="Live Products"
    >
      <Header />
       <ProductFilter masters={masters} onSearch={applysearch} onFilter={applyfilter}/> 
      <Results
        className={classes.results}
        orders={orders} //
        totalcount={orders ? orders.length : 0}
		    onStatusupdate={onUpdatestatus}
        onPageChange={onPageChange}
        onPageLimit={onPageLimit}
      />
     
    </Page>
  );
});

export default Products;
